import React, { useEffect, useState, useRef } from 'react';
interface StatItemProps {
  number: string;
  label: string;
  variant: 'neon' | 'blue' | 'white';
  delay?: number;
}
function StatItem({
  number,
  label,
  variant,
  delay = 0
}: StatItemProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setTimeout(() => setIsVisible(true), delay * 100);
      }
    }, {
      threshold: 0.3
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [delay]);
  const colorClass = variant === 'neon' ? 'text-[var(--neon)] [text-shadow:0_0_30px_rgba(204,255,0,0.5),0_0_60px_rgba(204,255,0,0.2)]' : variant === 'blue' ? 'text-[var(--blue)] [text-shadow:0_0_30px_rgba(0,87,255,0.5)]' : 'text-[var(--text)]';
  return <div ref={ref} className={`p-8 text-center border-r border-[var(--border)] last:border-r-0 relative transition-all duration-[0.25s] hover:bg-[var(--surface)] reveal ${isVisible ? 'visible' : ''}`} role="listitem" data-id="element-223">
      <div className={`font-black text-[clamp(40px,5vw,64px)] tracking-[-0.04em] leading-none mb-2 ${colorClass}`} aria-label={`${number} ${label}`} data-id="element-224">
        {number}
      </div>
      <div className="text-[13px] text-[var(--text-muted)] font-medium" data-id="element-225">
        {label}
      </div>
    </div>;
}
export function Stats() {
  return <div className="bg-[var(--bg-2)] border-t border-b border-[var(--border)]" data-id="element-226">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 py-8 md:py-[60px] px-6 max-w-[1200px] mx-auto" role="list" aria-label="Estadísticas de Oriam Marketing" data-id="element-227">
        <StatItem number="50+" label="Webs Creadas" variant="neon" delay={0} data-id="element-228" />
        <StatItem number="247%" label="Aumento Conversiones Promedio" variant="blue" delay={1} data-id="element-229" />
        <StatItem number="7 días" label="Tiempo de Entrega" variant="white" delay={2} data-id="element-230" />
        <StatItem number="98%" label="Satisfacción de Clientes" variant="neon" delay={3} data-id="element-231" />
      </div>
    </div>;
}